import { Box } from '@pco/atoms/Box';
import { Button } from '@pco/atoms/Button';
import { Dialog } from '@pco/atoms/Dialog';
import { Typography } from '@pco/atoms/Typography';
import { breakpointUtils } from '@pco/brandThemes/toyota';
import { useConfig } from '@pco/molecules/Config';

interface SessionTimeoutModalProps {
	title: string;
	subtitle: string;
	isOpen: boolean;
	onOpenChange: (value: boolean) => void;
	primaryLabel?: string;
	secondaryLabel?: string;
	onPrimaryClick?: () => void;
}

export const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
	title,
	subtitle,
	isOpen,
	onOpenChange,
	primaryLabel,
	secondaryLabel,
	onPrimaryClick,
}) => {
	const { useMobileBreakpoint } = breakpointUtils;
	const isMobile = useMobileBreakpoint({ up: false });

	const { REACT_APP_ACCOUNT_REGISTRATION_URL: registrationUrl } = useConfig();

	const currentPath = window.location.pathname;
	const createAccountLink = `${registrationUrl}?redirectUri=${encodeURIComponent(currentPath)}`;

	return (
		<Dialog open={isOpen} onOpenChange={onOpenChange} title={title}>
			<Dialog.Content>
				<Dialog.Header>
					<Dialog.Title>
						<Typography _size="h3" $weight="semibold" $letterSpacing="narrow">
							{title}
						</Typography>
					</Dialog.Title>
					<Dialog.Description>
						<Typography _size="body16">{subtitle}</Typography>
					</Dialog.Description>
				</Dialog.Header>
				<Dialog.Footer>
					<Box
						display="flex"
						flexDirection={isMobile ? 'column' : 'row'}
						alignItems="center"
						justifyContent={isMobile ? 'stretch' : 'flex-end'}
						gap="20px"
						width="100%"
					>
						{isMobile ? (
							<>
								{primaryLabel && (
									<Dialog.Save asChild>
										<Button
											_kind="brand"
											_size="lg"
											style={{ width: '100%' }}
											onClick={onPrimaryClick}
										>
											{primaryLabel}
										</Button>
									</Dialog.Save>
								)}
								{secondaryLabel && (
									<Dialog.Close asChild>
										<Button
											_kind="secondary"
											_size="lg"
											style={{ width: '100%' }}
											// @ts-expect-error withActions is dropping `as`
											as="a"
											href={createAccountLink}
										>
											{secondaryLabel}
										</Button>
									</Dialog.Close>
								)}
							</>
						) : (
							<>
								{secondaryLabel && (
									<Dialog.Close asChild>
										<Button
											_kind="secondary"
											_size="lg"
											// @ts-expect-error withActions is dropping `as`
											as="a"
											href={createAccountLink}
										>
											{secondaryLabel}
										</Button>
									</Dialog.Close>
								)}
								{primaryLabel && (
									<Dialog.Save asChild>
										<Button _kind="brand" _size="lg" onClick={onPrimaryClick}>
											{primaryLabel}
										</Button>
									</Dialog.Save>
								)}
							</>
						)}
					</Box>
				</Dialog.Footer>
			</Dialog.Content>
		</Dialog>
	);
};

export default SessionTimeoutModal;
